<template>
    <b-modal v-model="showLocal" id="edit-project" modal-class="modal--edit" :title="project.name">
        <label> <span>{{$t('files.base.title')}}</span> <input type="text" class="inp" v-model="project.name"> </label>
        <color-picker v-model="project.color"></color-picker>

        <template v-slot:modal-footer="{ cancel, ok }">
            <div class="modal__footer--left">
                <b-button variant="-ternary btn--outline" @click="cancel()">
                    {{$t('buttons.cancel')}}
                </b-button>
            </div>
            <div class="modal__footer--right">
                <b-button variant="-primary" @click="save()">
                    {{$t('buttons.save')}}
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
  import ColorPicker from "../../ColorPicker";
  import {mapActions} from 'vuex'
  export default {
    name: "EditProject",
    props:['project', 'show'],
    components: {
      ColorPicker
    },
    methods: {
      ...mapActions(['updateProject']),
      close(){
        this.$emit('hide', false)
      },
      save(){

        this.updateProject(this.project).then(({data}) => {
          if(data.success){
            this.close()
          }
        }).catch((e) => {
          console.log(e);
          //TODO: close popup, show message
        });
      }
    },
    computed: {
      showLocal: {
        get: function() {
          return this.show
        },
        set: function() {
          this.close()
        }
      }

    }
  }
</script>

<style scoped>

</style>
